import pinia from "../store/pinia";
import qs from "qs";
import { useSettingsStore } from "../../_generic/stores/settings";
import axios from "axios";

axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: "brackets" });
};

axios.interceptors.response.use(
  (response) => {
    // Any status code that lies within the range of 2xx causes this function to trigger
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx causes this function to trigger
    if (error.response && error.response.status === 401) {
      // CRITICAL CHECK: Prevent infinite redirect loops.
      // If the 401 came from our initial `profile/me` boot-up check, we do NOT want to
      // automatically redirect. We just want the app to render in a logged-out state.
      const isInitialSessionCheck =
        error.config.url === "profile/me" || error.config.url === "login";

      if (!isInitialSessionCheck) {
        // A standard API call (like fetching data or submitting a form) failed because
        // the session is dead and Rails couldn't refresh it.
        console.warn("Session expired");

        const settingsStore = useSettingsStore(pinia);
        if (settingsStore.oidc) {
          // Hard redirect to the Rails login route to restart the OIDC flow
          window.location.href = "/auth/login";
        } else {
          window.location.href = "/";
        }
      }
    }

    // Always reject the promise so the calling component's catch() block still executes
    return Promise.reject(error);
  }
);

export default axios;
